import { Pipe, PipeTransform, inject } from '@angular/core';
import { TimeBlockProjectModel } from '../../../../../core/models/timeblock/time-block.model';
import Color from 'color';
import { ITimeBlockComponentItem } from '../types/time-block-component-item-types';
import { TimeBlockContentType, TimeBlockType } from '../types/time-block-types';
import { TimeBlockService } from '../services/time-block.service';
import { assert } from '../../../../../core/assert/assert';

@Pipe({
  name: 'timeBlockColor',
  standalone: false,
})
export class TimeBlockColorPipe implements PipeTransform {
  private readonly timeBlockService = inject(TimeBlockService);

  transform(timeBlockComponentItem: ITimeBlockComponentItem, brightness = 0, opacity = 1): string {
    if (
      timeBlockComponentItem.timeBlockModel.type === TimeBlockType.NonExistingBlock ||
      this.timeBlockService.isDefaultTimeBlock(timeBlockComponentItem)
    ) {
      return '';
    }

    if (timeBlockComponentItem.timeBlockContentType === TimeBlockContentType.Project) {
      return this.getTimeBlockProjectColor(timeBlockComponentItem, brightness, opacity);
    }
  }

  private getTimeBlockProjectColor(
    timeBlockComponentItem: ITimeBlockComponentItem,
    brightness: number,
    opacity: number,
  ): string {
    const timeBlockModel = timeBlockComponentItem.timeBlockModel as TimeBlockProjectModel;

    assert(!!timeBlockModel.project.color, 'Project color is undefined.');
    const colorStr = timeBlockModel.project.color;

    if (timeBlockModel.fixInterval !== null) {
      return colorStr;
    }

    let color = Color(colorStr);
    if (opacity !== 1) {
      color = color.alpha(opacity);
    }

    return color.lighten(brightness).rgb().toString();
  }
}
